import { Component } from '@angular/core';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { GbgrundstueckService } from '../../../core/gb-api';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../../core/services/timepoint.service';
import { AppConfigService } from '../../../core/services/app-config.service';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { OerebTableAlleComponent } from '../../../oereb/oereb-alle/oereb-table-alle.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-oereb-rubrik',
  templateUrl: './grundstueck-oereb-rubrik.component.html',
  imports: [RubrikComponent, OerebTableAlleComponent, TranslatePipe]
})
export class GrundstueckOerebRubrikComponent extends AbstractGrundstueckEntryFromRoute {
  constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
  }

  loadData() {
    // nothing to load
  }
}
